import React from "react";
import PropTypes from 'prop-types';

const Monroney = ({
    electricRange,
    totalRange,
    isBEV,
}) => {
    // Every 100 miles is 10.53
    const electricWidth = Number(electricRange / 10.53)

    // -22 represents placement at 0. Every 100 miles is 9 and since we want to place in the middle, we divide the range by 2
    const lightningBoltCoordinate = -22 + Number(electricRange * 9 / 200)
    const lightningBoltPlacement = `matrix(0.03048031,0,0,0.03048031,${lightningBoltCoordinate},-0.64888491)`

    // Initial coordinates if total range is over 400
    let carCoordinate = -0.6721443
    let totalRangeCoordinate = 40.9577
    let gasolineCoordiante = 39.588596

    // Gas can is placed in the middle of the gasoline range. The middle is calculated by taking the average of the electric and total range and multipyling it by 10 for every 100 miles.  This only applies for vehicles less than 400 total range. 
    let gasCanCoordinate = -24 + ((electricRange + totalRange) / 200 * 10)

    if (totalRange < 400) {
        // Car must move if the total range is less than 400.  -40 represents placement at 0.  Every 100 miles is 9.5
        carCoordinate = -40 + Number(totalRange * 9.5 / 100)
        // Same logic applies to the total range text beneath the car.  The +1 is for some additional accuracy
        totalRangeCoordinate = Number(totalRange * 9.5 / 100) + 1
        gasolineCoordiante = Number(totalRange * 9.5 / 100) - .2
    } else {
        // For gas vehicles with range over 400, we find the middle between the electric range and 400 and apply the same logic of 10 per 100 miles. 
        gasCanCoordinate = -24 + ((electricRange + 400) / 200 * 10)
    }

    const carPlacement = `matrix(0.59253426,0,0,0.59253426,${carCoordinate},2.6965049)`
    const gasCanPlacement = `translate(${gasCanCoordinate},-0.2952939)`

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            id="svg8"
            version="1.1"
            viewBox="0 12.75 51.055119 15"
            height="18mm"
            width="70mm">
        <defs
            id="defs2">
            <linearGradient
            id="linearGradient4791"
            osbpaint="gradient">
            <stop
                style={{stopColor:"#59bec9",stopOpacity:1}}
                offset="0"
                id="stop4787" />
            <stop
                style={{stopColor:"#73767b",stopOpacity:0.98039216}}
                offset="1"
                id="stop4789" />
            </linearGradient>
            <linearGradient
            osbpaint="solid"
            id="linearGradient4612">
            <stop
                id="stop4610"
                offset="0"
                style={{stopColor:"#0000b1",stopOpacity:1}} />
            </linearGradient>
            <linearGradient
            osbpaint="gradient"
            id="linearGradient4583">
            <stop
                id="stop4579"
                offset="0"
                style={{stopColor:"#7b0036",stopOpacity:0.99130434}} />
            <stop
                id="stop4581"
                offset="1"
                style={{stopColor:"#0000b1",stopOpacity:0}} />
            </linearGradient>
            <linearGradient
            gradientUnits="userSpaceOnUse"
            y2="50.443859"
            x2="57.730217"
            y1="49.642052"
            x1="93.878418"
            id="linearGradient4585"
            xlinkHref="#linearGradient4583" />
            <filter
            height="5.3001246"
            y="-2.1500623"
            width="2.5137186"
            x="-0.7568593"
            id="filter4606"
            style={{colorInterpolationFilters:"sRGB"}} >
            <feGaussianBlur
                id="feGaussianBlur4608"
                stdDeviation="17.908041" />
            </filter>
            <linearGradient
            y2="38.516956"
            x2="24.054258"
            y1="38.316505"
            x1="0.43501574"
            gradientUnits="userSpaceOnUse"
            id="linearGradient4785"
            xlinkHref="#linearGradient4791" />
            <linearGradient
            id="linearGradient1183"
            osbpaint="solid">
            <stop
                style={{stopColor:"#ffffd1", stopOpacity:1}}
                offset="0"
                id="stop1181" />
            </linearGradient>
        </defs>
        <g
            transform="translate(0.08148691,-22.197499)"
            id="layer1">
            <rect
                y="46.729801"
                x="38.380886"
                height="19.989792"
                width="56.786377"
                id="rect4518"
                style={{fill:"none",fillOpacity:1,stroke:"#000000",strokeWidth:0.62800002,strokeMiterlimit:4,strokeDasharray:"none",strokeOpacity:0}} />
            <rect
                className="monroney_gasoline_graph"
                id="monroney_gasoline_graph"
                y="34.073193"
                x="0.43501574"
                height="8.4866285"
                width={gasolineCoordiante}
                style={{opacity:0.86000001,fill:"#73767b",fillOpacity:1,stroke:"none",strokeWidth:0.44505709,strokeMiterlimit:4,strokeDasharray:"none",strokeOpacity:1,display: isBEV ? "none" : null}} />

            {/* Gasoline Milage */}
            {/* {electricRange !== totalRange &&
                <> 
                    <text
                    id="text4662-0"
                    y="25.339426"
                    x="35.845562"
                    style={{fontStyle:"normal",fontWeight:"normal",fontSize:"4.58611107px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                    xmlSpace="preserve">
                        <tspan
                        style={{fontStyle:"normal",fontVariant:"normal",fontWeight:"normal",fontStretch:"normal",fontSize:"4.23333311px",fontFamily:"sans-serif",strokeWidth:0.26458332}}
                        y="25.339426"
                        x="35.845562"
                        id="tspan4660-9">
                            {totalRange - electricRange}
                        </tspan>
                    </text>
                    <text
                    id="text4670-9"
                    y="29.715963"
                    x="34.320683"
                    style={{fontStyle:"normal",fontWeight:"normal",fontSize:"10.58333302px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                    xmlSpace="preserve">
                        <tspan
                            style={{fontSize:"2.82222223px",lineHeight:"21.27249908px",strokeWidth:0.26458332}}
                            y="29.715963"
                            x="34.320683"
                            id="tspan4668-4">
                                gasoline
                        </tspan>
                    </text>
                </>
            } */}

            {/*  */}
            <text
                className="monroney_text_millage_ellipsis"
                id="text4670-9-0-3"
                y="45.066124"
                x="38.053345"
                style={{fontStyle:"normal",fontWeight:"normal",fontSize:"2.11666656px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                xmlSpace="preserve">
                <tspan
                    style={{fontSize:"2.11666656px",lineHeight:"21.27249908px",strokeWidth:0.26458332, display: totalRange < 300 ? "none" : null}}
                    y="45.066124"
                    x="38.053345"
                    id="tspan4668-4-7-7">
                        ...
                </tspan>
            </text>
            <text
                className="monroney_text_millage_300"
                id="text4670-9-0-3-4"
                y="45.160751"
                x="27.791666"
                style={{fontStyle:"normal",fontWeight:"normal",fontSize:"2.11666656px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                xmlSpace="preserve">
                <tspan
                    style={{fontSize:"2.11666656px",lineHeight:"21.27249908px",strokeWidth:0.26458332, display: totalRange < 200 ? "none" : null}}
                    y="45.160751"
                    x="27.791666"
                    id="tspan4668-4-7-7-9">
                        300
                </tspan>
            </text>
            <text
                id="text4670-9-0-1"
                y="45.197044"
                x="8.1027651"
                style={{fontStyle:"normal",fontWeight:"normal",fontSize:"2.11666656px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                xmlSpace="preserve">
                <tspan
                    style={{fontSize:"2.11666656px",lineHeight:"21.27249908px",strokeWidth:0.26458332}}
                    y="45.197044"
                    x="8.1027651"
                    id="tspan4668-4-7-5">
                        100
                </tspan>
            </text>
            <text
                className="monroney_text_millage_200"
                id="text4670-9-0-3-2"
                y="45.119034"
                x="17.900488"
                style={{fontStyle:"normal",fontWeight:"normal",fontSize:"2.11666656px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                xmlSpace="preserve">
                <tspan
                    style={{fontSize:"2.11666656px",lineHeight:"21.27249908px",strokeWidth:0.26458332, display: totalRange < 100 ? "none" : null}}
                    y="45.119034"
                    x="17.900488"
                    id="tspan4668-4-7-7-3">
                        200
                </tspan>
            </text>
            <text
                id="text4670-9-0-3-4-5"
                y="45.213661"
                x="-0.22308032"
                style={{fontStyle:"normal",fontWeight:"normal",fontSize:"2.11666656px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                xmlSpace="preserve">
                <tspan
                    style={{fontSize:"2.11666656px",lineHeight:"21.27249908px",strokeWidth:0.26458332}}
                    y="45.213661"
                    x="-0.22308032"
                    id="tspan4668-4-7-7-9-4">
                        0
                </tspan>
            </text>

            {/* Electric Milage */}
            {/* <g
            id="g4748-1"
            transform="translate(-32.313766,-1.6802574)">
                <text
                    xmlSpace="preserve"
                    style={{fontStyle:"normal",fontWeight:"normal",fontSize:"4.58611107px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                    x="41.925945"
                    y="27.071306"
                    id="text4662-0-2">
                    <tspan
                        id="tspan4660-9-6"
                        x="41.925945"
                        y="27.071306"
                        style={{fontStyle:"normal",fontVariant:"normal",fontWeight:"normal",fontStretch:"normal",fontSize:"4.23333311px",fontFamily:"sans-serif",strokeWidth:0.26458332}}>
                            {electricRange}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{fontStyle:"normal",fontWeight:"normal",fontSize:"10.58333302px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                    x="39.326614"
                    y="31.447842"
                    id="text4670-9-9">
                    <tspan
                        id="tspan4668-4-8"
                        x="39.326614"
                        y="31.447842"
                        style={{fontSize:"2.82222223px",strokeWidth:0.26458332}}>
                            electric
                    </tspan>
                </text>
            </g> */}

            {/* Milage (under graph) */}
            <rect
                className="monroney_electric_graph"
                electric_square=""
                id="monroney_electric_graph"
                y="34.073193"
                x="0.43501574"
                height="8.4866285"
                width={electricWidth}
                style={{opacity:0.86000001,fill:"#59bec9",fillOpacity:1,stroke:"none",strokeWidth:0.19392391,strokeMiterlimit:4,strokeDasharray:"none",strokeOpacity:1}} />

            <text
                className="monroney_text_millage"
                id="text4670-9-0-3-4-9"
                y="49.486351"
                x="16.153019"
                style={{fontStyle:"normal",fontWeight:"normal",fontSize:"2.11666656px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                xmlSpace="preserve">
                <tspan
                    style={{fontSize:"2.11666656px",lineHeight:"21.27249908px",strokeWidth:0.26458332}}
                    y="49.486351"
                    x="16.153019"
                    id="tspan4668-4-7-7-9-0">
                        Mileage
                </tspan>
            </text>

            {/* Miles (under car) */}
            <text
                className="monroney_text_total_miles"
                id="text4670-9-0-3-4-2"
                y="42.541039"
                x="40.957706"
                style={{fontStyle:"normal",fontWeight:"normal",fontSize:"2.11666656px",lineHeight:1.25,fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none",strokeWidth:0.26458332}}
                xmlSpace="preserve">
                <tspan
                    style={{fontSize:"2.11666656px",lineHeight:"21.27249908px",strokeWidth:0.26458332}}
                    y="42.541039"
                    x={totalRangeCoordinate}
                    id="tspan4668-4-7-7-9-1">
                        {totalRange} Miles
                </tspan>
            </text>

            {/* Gas Can and Lightning Bolt */}
            <g
                transform="translate(20.94336,36.050477)"
                id="g5033">

                {/* Gas Can */}
                <g
                    transform={gasCanPlacement}
                    style={{display:"inline",fill:"#ffffff",fillOpacity:1}}
                    id="layer2">
                    <path
                    className="monroney_image_gascan"
                    style={{fill:"#ffffff",fillOpacity:1,stroke:"#000000",strokeWidth:0.02,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:4,strokeDasharray:"none",strokeOpacity:1, display: isBEV ? "none" : null}}
                    d="m 1.236071,-0.02133869 c -0.133165,0.0065 -0.269963,0.02641 -0.382921,0.022219999 C 0.627227,-0.00751869 0.420511,0.01138131 0.282642,0.04481131 c -0.275741,0.06683 -0.275759,0.192577 -0.27182,0.99735499 0.0039,0.804775 0.01178,2.282227 0.01964,3.144509 0.0079,0.862285 0.0157,1.106168 0.01964,1.22835 0.0039,0.122182 0.0038,0.122205 0.661458,0.106452 0.657659,-0.01574 1.947297,0.0613 2.608628,-0.01757 0.763334,0.01627 0.689443,-0.16814 0.673343,-0.794269 -0.01516,-0.589224 0.02897,-1.755523 -0.02222,-2.35386 C 3.920121,1.7574413 3.817821,1.6155293 3.683989,1.4462733 3.550158,1.2770163 3.384677,1.0801213 3.19978,0.98170131 c -0.184896,-0.09842 -0.39689,-0.03148 -0.68213,-0.05994 -0.226772,-0.220564 -0.550368,-0.6693 -0.920871,-0.885735 -0.09807,-0.05729 -0.227537,-0.0639 -0.360704,-0.05736 z m 3.468523,0.244428 -0.664043,0.627869 0.105936,0.129707 0.612884,-0.615466 0.710033,0.0057 v -0.136943 z m -3.282487,0.12764 c 0.140298,-0.0036 0.157546,0.0039 0.266134,0.09043 0.108585,0.08657 0.311499,0.2556 0.402042,0.361219 0.09054,0.105617 0.07141,0.150353 -0.07286,0.170014 -0.144278,0.01966 -0.415653,0.014 -0.567407,0.0098 -0.151757,-0.0042 -0.18473,-0.0072 -0.270269,-0.08992 -0.08554,-0.08274 -0.22124,-0.243075 -0.299207,-0.340547 -0.07796,-0.09747 -0.09725,-0.130615 -0.106969,-0.147278 -0.0097,-0.01667 -0.0097,-0.01696 0.119888,-0.02532 0.129599,-0.0084 0.388353,-0.02479 0.528651,-0.02842 z m 4.098975,0.117824 a 0.11619518,0.25556197 0 0 0 -0.116273,0.255281 0.11619518,0.25556197 0 0 0 0.116273,0.255799 0.11619518,0.25556197 0 0 0 0.116272,-0.255799 0.11619518,0.25556197 0 0 0 -0.116272,-0.255281 z m -2.010214,0.269751 c -0.09395,0.01103 -0.113159,0.04737 -0.122989,0.06563 -0.0098,0.01826 -0.01015,0.01829 -0.01292,0.04599 -0.0028,0.0277 -0.0078,0.08328 0.07286,0.21704299 0.08071,0.133755 0.245875,0.343008 0.391708,0.434596 0.14583,0.09159 0.267769,0.0608 0.331761,-0.02842 0.06399,-0.08921 0.06956,-0.23653 0.02222,-0.365869 C 4.146168,0.97793531 4.046183,0.86648031 3.911354,0.80393531 c -0.134829,-0.06255 -0.306538,-0.07666 -0.400492,-0.06563 z m -0.684712,1.46605899 0.284736,0.284739 -1.057814,1.057815 1.010271,1.010274 -0.285252,0.284737 -1.010275,-1.010272 -0.949811,0.950328 -0.28474,-0.284737 0.950331,-0.949812 -0.99839,-0.998389 0.285256,-0.284737 0.99787,0.997871 z"
                    id="path1156" />
                </g>

                {/* Lightning Bolt */}
                <g
                    transform={lightningBoltPlacement}
                    id="lightningBolt"
                    style={{fill:"none", display:electricRange < 40 ? "none" : null}}>
                    <path
                    style={{stroke:"#ffffff",strokeWidth:11.0472002,strokeMiterlimit:10}}
                    d="M 74.2822,25 11,115.587 41.0101,116.139 28.6146,176.347 93.854,84.6549 63.1915,85.2072 Z"
                    strokeMiterlimit="10"
                    id="path5035" />
                </g>
            </g>

            {/* Car */}
            <g
            className="monroney_graphic_car"
            transform={carPlacement}
            id="g5187">
            <path
                style={{fill:"#000000",fillOpacity:1,stroke:"#000000",strokeWidth:"0.99999994px",strokeLinecap:"butt",strokeLinejoin:"miter",strokeOpacity:1}}
                d="m 283.66211,212.82617 c -5.16295,0.0859 -10.61867,1.88774 -15.44141,6.01953 l -2.6289,4.73047 -0.91407,7.44141 2.63477,2.69336 c 3.28304,-2.18005 6.44909,-4.87008 11.36328,0.12695 l 15.15234,0.37891 c 4.68942,-4.9954 8.85798,-3.48756 12.87891,-0.12696 l 5.68359,-0.25195 c 0.68916,-13.09425 -12.5555,-9.84812 -19.95117,-19.44531 -2.68639,-1.05115 -5.67957,-1.61797 -8.77734,-1.56641 z m 1.70445,3.52788 2.67641,-0.10991 2.52734,0.36328 c 2.25308,0.53674 5.67946,2.54842 7.19727,6.70899 h -12.44531 z m -1.89195,-0.19389 0.125,7.07031 -11.23047,-0.25781 c 2.07701,-6.42881 7.31024,-6.37563 11.10547,-6.8125 z"
                transform="scale(0.26458333)"
                id="path5059" />
            <path
                style={{fill:"#ffffff",fillOpacity:1,stroke:"none",strokeWidth:0.53100002,strokeMiterlimit:4,strokeDasharray:"none",strokeOpacity:1}}
                id="path5061"
                d="m 72.02914,63.205982 a 0.61806077,1.0690781 0 0 1 -0.40783,1.005332" />
            <circle
                style={{fill:"#000000",fillOpacity:1,stroke:"#ffffff",strokeWidth:0.26458332,strokeMiterlimit:4,strokeDasharray:"none",strokeOpacity:0.94117647}}
                id="path5069-5"
                cx="79.479279"
                cy="61.502136"
                r="1.2695302" />
            <circle
                style={{fill:"#ffffff",fillOpacity:1,stroke:"#000000",strokeWidth:0.13847055,strokeMiterlimit:4,strokeDasharray:"none",strokeOpacity:1}}
                id="path5069-2-2"
                cx="79.521042"
                cy="61.485432"
                r="0.66441274" />
            <circle
                style={{fill:"#000000",fillOpacity:1,stroke:"#ffffff",strokeWidth:0.26458332,strokeMiterlimit:4,strokeDasharray:"none",strokeOpacity:0.94117647}}
                id="path5069-5-4"
                cx="72.25251"
                cy="61.603516"
                r="1.2695302" />
            <circle
                style={{fill:"#ffffff",fillOpacity:1,stroke:"#000000",strokeWidth:0.13847055,strokeMiterlimit:4,strokeDasharray:"none",strokeOpacity:1}}
                id="path5069-2-2-8"
                cx="72.294273"
                cy="61.586811"
                r="0.66441274" />
            </g>
        </g>
    </svg>
    )
}
    
export default Monroney;

Monroney.propTypes = {
    electricRange: PropTypes.number,
    totalRange: PropTypes.number,
    isBEV: PropTypes.bool
};
